import * as R from 'ramda';
import React from 'react';

import {translate} from 'iss/strings';
import {AccordionFormSection as Section} from 'iss/widgets/AccordionForm';
import {FormSection} from 'iss/widgets/Forms';
import {
  EvaluationFormSelector,
  PartySelector,
  ServiceRadioSelector,
  ServiceTypeRadioSelector,
  SiteSizeSelector
} from 'iss/widgets/Selectors';
import validators  from 'iss/widgets/form/validation/validators';

export function ServiceSelectorSection() {
  return <Section id='serviceTypeChooser' title={translate('evaluationActivator.serviceTypeSectionTitle')}>
    <FormSection>
      {(values, formApi) =>
        <React.Fragment>
          <ServiceTypeRadioSelector label="evaluationActivator.serviceType" id="serviceType" valuePath="serviceType"
            onChange={() => formApi.setValue("service", null)}
            validate={validators.chooseOne}/>
          <ServiceRadioSelector label="evaluationActivator.service" id="service" serviceType={values.serviceType}
            valuePath="service" validate={validators.chooseOne}/>
        </React.Fragment>
      }
    </FormSection>
  </Section>;
}

export function filterForm(form, {service, siteSize}) {
  if(R.none(s => s.id == service, form.serviceTypes)) return false;
  if(siteSize && R.none(R.equals(siteSize), form.siteSizes)) return false;
  return true;
}

export function FormSelectorSection({activation}) {
  const shouldShowForm = (form) => filterForm(form, activation);

  return <Section id='formChooser' title={translate('evaluationActivator.formChooserSectionTitle')}>
    <SiteSizeSelector label="evaluationActivator.siteSize" id="siteSize" valuePath="siteSize" clearable={true} />
    <EvaluationFormSelector label="evaluationActivator.evaluationForm" id="form" valuePath="form"
      context="QUALITY_ASSURANCE"
      key={[activation.service, activation.siteSize]}
      validate={validators.chooseOne} filter={shouldShowForm} />
  </Section>;
}

export function PartySelectorSection({parties}) {
  const selectedParties = R.values(parties).reduce(R.concat, []);

  return <Section id='responsibleParties' title={translate('evaluationActivator.responsiblePartiesSectionTitle')}>
    <PartySelector label="evaluationActivator.siteCoordinators" multi={true} excludedParties={selectedParties}
      id="siteCoordinators" valuePath="parties.siteCoordinators" validate={validators.chooseAtLeastOne} />
    <PartySelector creatable label="evaluationActivator.informants" multi={true} excludedParties={selectedParties}
      id="informants" valuePath="parties.informants" />
  </Section>;
}



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/activation/ActivatorSections.jsx